import "../scss/page.scss";

import "../scss/consultations.scss";
import "./scripts/consultations/base.js";